import { useEffect } from 'react';
import PageFooter from 'components/Footer/Footer';
import HomeHeader from 'components/HomeHeader/HomeHeader';
import { Container } from 'nhsuk-react-components';
import { INTENDED_URL } from '../constants/links';

function NotFoundPage() {
  useEffect(() => {
    sessionStorage.removeItem(INTENDED_URL);
  }, []);

  return (
    <>
      <HomeHeader />
      <Container>
        <h1 className="nhsuk-u-padding-top-6">
          Sorry, there is a problem with this page
        </h1>
        <p className="nhsuk-u-padding-top-1">
          We cannot show this page right now.
        </p>
        <p>This could be because:</p>
        <ul>
          <li>we’re having a technical problem</li>
          <li>the page does not exist</li>
          <li>you do not have permission to view this page</li>
        </ul>
        <p>Please go back to the home page using the link below.</p>
        <p>
          If the problem continues, contact the SPI team at
          {' '}
          <a href="mailto:england.invitationservicesupport@nhs.net">
            england.invitationservicesupport@nhs.net
          </a>
        </p>
        <div className="nhsuk-u-padding-top-4 nhsuk-u-padding-bottom-4">
          <a href="/">Back to home</a>
        </div>
      </Container>
      <PageFooter />
    </>
  );
}

export default NotFoundPage;
